export default "/dist/fonts/RobotoCondensed-Bold.ttf";